import { gql } from 'apollo-boost';

const createLoanedGQL = gql`
  mutation history(
    $hardwareID: String
    $loanID: String
    $timestamp: Date
    $comments: String
  ) {
    createLoaned(
      history: {
        hardwareID: $hardwareID
        loanID: $loanID
        timestamp: $timestamp
        comments: $comments
      }
    ) {
      hardwareID
      loanID
      timestamp
      comments
      returned
    }
  }
`;

export default createLoanedGQL;
